import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';

import { rootPrivateConnectionsSagas } from '~src/settings/privateconnect-settings/sagas/PrivateConnectSagas';
import { rootAvailableActionsForEntitySaga } from '~src/spacesPlatform/sagas/AvailableActionsForEntitySagas';
import { rootSpacesSaga } from '~src/spacesPlatform/sagas/RootSpacesSaga';
import { rootServerUsersSpaceSaga } from '~src/userManagement/sagas/ServerUserSpaceSagas';

import { rootRequestFailedSaga } from '../../bootstrap/redux/sagas/RequestFailedSaga';
import { rootDraftsSaga } from '../../drafts/sagas/DraftsSagas';
import { rootPersonalSpaceSaga } from '../../personalSpace/sagas/PersonalSpaceSaga';
import { rootSiteSagas } from '../../siteManagement/sagas/SitesSagas';
import { rootDisplayModeSaga } from '../../spacesPlatform/sagas/DisplayModeSaga';
import { rootStartersSaga } from '../../starters/sagas/StartersSagas';
import { rootUploadContentSaga } from '../../uploadContent/sagas/UploadContentSaga';
import { rootUserNotificationSettingsSagas } from '../../userNotifications/redux/sagas/UserNotificationSettingsSaga';
import { rootUserNotificationSagas } from '../../userNotifications/redux/sagas/UserNotificationsSaga';

export function* rootSaga(): SagaIterator {
  yield all([
    fork(rootDisplayModeSaga),
    fork(rootSpacesSaga),
    fork(rootRequestFailedSaga),
    fork(rootAvailableActionsForEntitySaga),
    fork(rootSiteSagas),
    fork(rootStartersSaga),
    fork(rootUploadContentSaga),
    fork(rootDraftsSaga),
    fork(rootUserNotificationSagas),
    fork(rootUserNotificationSettingsSagas),
    fork(rootPersonalSpaceSaga),
    fork(rootServerUsersSpaceSaga),
    fork(rootPrivateConnectionsSagas)
  ]);
}
